<form [formGroup]="form">
  <div class="form-viewer">
    @if (loading) {
    <!-- Loading Skeleton -->
    <div class="form-skeleton">
      <div class="content-skeleton">
        <!-- Section Title Skeleton -->
        <p-skeleton width="200px" height="24px" styleClass="mb-3"></p-skeleton>

        <!-- Fields Skeleton -->
        <div class="grid">
          <div class="col-12 md:col-6">
            <p-skeleton height="40px" styleClass="mb-2"></p-skeleton>
            <p-skeleton height="40px" styleClass="mb-2"></p-skeleton>
            <p-skeleton height="40px" styleClass="mb-2"></p-skeleton>
          </div>
          <div class="col-12 md:col-6">
            <p-skeleton height="40px" styleClass="mb-2"></p-skeleton>
            <p-skeleton height="40px" styleClass="mb-2"></p-skeleton>
            <p-skeleton height="40px" styleClass="mb-2"></p-skeleton>
          </div>
        </div>
      </div>
    </div>
    } @else if (formDefinition) {

    <!-- Section rendering template -->
    <ng-template #sectionTemplate let-sections="sections" let-tabIndex="tabIndex">
     <div *ngFor="let section of sections; let sectionIndex = index" class="section"
    [attr.data-section-id]="section.id"
    [class.duplicate-address-section]="isDuplicateAddressSection(section.id)">
    <div class="section-header">
      <div class="section-header-content">
        <div class="section-title-wrapper">
          <h2 class="section-title">{{ section.title }}</h2>
          <p *ngIf="section.hint" class="section-hint">{{ section.hint }}</p>
        </div>
        <p-button *ngIf="enableSectionCollapse"
          [icon]="isSectionExpanded(tabIndex, sectionIndex) ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
          (onClick)="toggleSection(tabIndex, sectionIndex)" [text]="true"
          [pTooltip]="isSectionExpanded(tabIndex, sectionIndex) ? 'Collapse section' : 'Expand section'"
          tooltipPosition="top"></p-button>
      </div>

      <!-- ⭐ Duplicate address warning -->
      <div *ngIf="isDuplicateAddressSection(section.id)" class="mb-2 p-2 border-round" style="
         border: 1px solid #dc2626 !important;
  background-color: #fef2f2;
          font-size: 11px;
          white-space: normal;
          word-wrap: break-word;
        ">
        <i class="pi pi-exclamation-triangle mr-1"></i>
        This address matches another address in the form. Please review.
      </div>
    </div>

        <div *ngIf="isSectionExpanded(tabIndex, sectionIndex)" class="section-content">
          <div *ngFor="let row of section.rows" class="row">
            <!-- Regular Row -->
            <ng-container *ngIf="!row.isRepeatableRow">
              <div *ngFor="let columnFields of row.fields; let colIndex = index" class="column"
                [ngClass]="'column-' + row.columns">
                <ng-container *ngFor="let field of columnFields">
                  <div *ngIf="isFieldVisible(field.key)" class="field">
                    <app-field-renderer [field]="field" [fieldKey]="field.key" [parentFormGroup]="form"
                      [readonly]="readonly" [fieldEnabled]="isFieldEnabled(field.key)">
                    </app-field-renderer>
                  </div>
                </ng-container>
              </div>
            </ng-container>


            <!-- Complex Keyword Row -->
            <div *ngIf="row.isRepeatableRow && row.repeatableKeywordField && row.type === 'Complex'"
              class="complex-field-container" [formGroupName]="row.repeatableKeywordField.key">
              <div class="complex-field-header">
                <h3 class="complex-field-title">{{ row.repeatableKeywordField.label }}</h3>
                <div>
                  <p-button *ngIf="
                      enableCopyPaste &&
                      !readonly &&
                      !row.repeatableKeywordField.readOnly &&
                      shouldShowCopyPaste(row.repeatableKeywordField)
                    " icon="pi pi-copy" [text]="true"
                    [loading]="isComplexInstanceLoading(row.repeatableKeywordField.key)"
                    [disabled]="isComplexInstanceLoading(row.repeatableKeywordField.key)"
                    (onClick)="copyComplexInstance(row.repeatableKeywordField.key)" pTooltip="Copy this entry"
                    tooltipPosition="top">
                  </p-button>
                </div>
              </div>

              <div class="complex-content">
                <div class="sub-fields-grid" [class]="'columns-' + getColumnLayout(row.repeatableKeywordField)">
                  <ng-container *ngFor="let subField of getSubFields(row.repeatableKeywordField)">
                    <div *ngIf="isComplexSubFieldVisible(subField, row.repeatableKeywordField.key)" class="sub-field">
                      <app-field-renderer [field]="subField" [fieldKey]="subField.key"
                        [parentFormGroup]="getComplexInstance(row.repeatableKeywordField.key)"
                        [readonly]="getComplexFieldReadonlyState(subField, row.repeatableKeywordField)"
                        [fieldEnabled]="isComplexSubFieldEnabled(subField, row.repeatableKeywordField.key)">
                      </app-field-renderer>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>

            <!-- Repeatable Keyword Row -->
            <div *ngIf="row.isRepeatableRow && row.repeatableKeywordField && row.type !== 'Complex'"
              class="repeatable-field-container" [formArrayName]="row.repeatableKeywordField.key">
              <div class="repeatable-field-header">
                <h3 class="repeatable-field-title">{{ row.repeatableKeywordField.label }}</h3>
                <div>
                  <p-button *ngIf="
                      enableCopyPaste &&
                      !readonly &&
                      !row.repeatableKeywordField.readOnly &&
                      shouldShowCopyPaste(row.repeatableKeywordField) &&
                      getRepeatableInstanceCount(row.repeatableKeywordField.key) === 1
                    " icon="pi pi-copy" [text]="true" [loading]="isInstanceLoading(row.repeatableKeywordField.key, 0)"
                    [disabled]="isInstanceLoading(row.repeatableKeywordField.key, 0)"
                    (onClick)="copyRepeatableInstance(row.repeatableKeywordField.key, 0)" pTooltip="Copy this entry"
                    tooltipPosition="top">
                  </p-button>
                  <p-button *ngIf="
                      enableCopyPaste &&
                      !readonly &&
                      !row.repeatableKeywordField.readOnly &&
                      shouldShowCopyPaste(row.repeatableKeywordField) &&
                      getRepeatableInstanceCount(row.repeatableKeywordField.key) > 1
                    " icon="pi pi-clone" [text]="true"
                    [loading]="isAllInstancesLoading(row.repeatableKeywordField.key)"
                    [disabled]="isAllInstancesLoading(row.repeatableKeywordField.key)"
                    (onClick)="copyAllRepeatableInstances(row.repeatableKeywordField.key)" pTooltip="Copy all entries"
                    tooltipPosition="top">
                  </p-button>
                  <p-button
                    *ngIf="!readonly && !row.repeatableKeywordField.readOnly && !isLookupDropdown(row.repeatableKeywordField)"
                    icon="pi pi-plus" [text]="true" (onClick)="addRepeatableInstance(row.repeatableKeywordField)"
                    [disabled]="getRepeatableInstanceCount(row.repeatableKeywordField.key) >= getMaxRepeatCount(row.repeatableKeywordField)"
                    [pTooltip]="
                      getRepeatableInstanceCount(row.repeatableKeywordField.key) >= getMaxRepeatCount(row.repeatableKeywordField)
                        ? 'Maximum number of entries reached'
                        : 'Add new entry'
                    " tooltipPosition="left">
                  </p-button>
                </div>
              </div>

              <div *ngIf="isLookupDropdown(row.repeatableKeywordField)" class="lookup-multiselect-row">
                <span class="lookup-dropdown-label">
                  {{ getSelectionFieldTooltip(row.repeatableKeywordField) || 'Select records' }}
                </span>
                <p-multiselect
                  [formControl]="getLookupMultiSelectControl(row.repeatableKeywordField)"
                  [options]="getLookupDropdownOptions(row.repeatableKeywordField)"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select records..."
                  class="w-full"
                  display="chip"
                  appendTo="body"
                  [filter]="true"
                  filterBy="label"
                  [disabled]="readonly || row.repeatableKeywordField.readOnly"
                  (onChange)="onLookupMultiSelectChange(row.repeatableKeywordField, $event.value)"
                ></p-multiselect>
              </div>

              <div class="repeatable-instances">
                <!-- Empty state message when no instances exist -->
                <div *ngIf="getRepeatableInstanceCount(row.repeatableKeywordField.key) === 0"
                  class="empty-state-message">
                  <i class="pi pi-info-circle"></i>
                  <p
                    *ngIf="isLookupDropdown(row.repeatableKeywordField) && !readonly && !row.repeatableKeywordField.readOnly">
                    No records selected. Choose one or more records from the list above.
                  </p>
                  <p *ngIf="
                      !isLookupDropdown(row.repeatableKeywordField) &&
                      !readonly &&
                      !row.repeatableKeywordField.readOnly &&
                      getRepeatableInstanceCount(row.repeatableKeywordField.key) < getMaxRepeatCount(row.repeatableKeywordField)
                    ">
                    No entries yet. Click "Add new entry" button above to add your first entry.
                  </p>
                  <p *ngIf="
                      readonly || row.repeatableKeywordField.readOnly || getRepeatableInstanceCount(row.repeatableKeywordField.key) >= getMaxRepeatCount(row.repeatableKeywordField)
                    ">
                    No entries.
                  </p>
                </div>

                <div
                  *ngFor="let instanceGroup of getRepeatableInstances(row.repeatableKeywordField.key); let instanceIndex = index"
                  class="repeatable-instance" [class]="'columns-' + getColumnLayout(row.repeatableKeywordField)"
                  [class.duplicate-instance]="isDuplicateInstance(row.repeatableKeywordField.key, instanceIndex)"
                  [id]="row.repeatableKeywordField.key + '-instance-' + instanceIndex"
                  [formGroupName]="instanceIndex.toString()">

                  <div class="instance-header">
                    <div class="instance-header-left">
                      <p-checkbox
                        *ngIf="row.repeatableKeywordField['enableItemSelection'] && !isLookupDropdown(row.repeatableKeywordField)"
                        [formControlName]="row.repeatableKeywordField['selectionFieldKey']" [binary]="true"
                        [disabled]="readonly"
                        [pTooltip]="getSelectionFieldTooltip(row.repeatableKeywordField)"></p-checkbox>
                      <span class="instance-label">{{ row.repeatableKeywordField.label }} #{{ instanceIndex + 1
                        }}</span>
                    </div>
                    <div>
                      <p-button
                        *ngIf="enableCopyPaste && !readonly && !row.repeatableKeywordField.readOnly && shouldShowCopyPaste(row.repeatableKeywordField)"
                        icon="pi pi-copy" [text]="true"
                        [loading]="isInstanceLoading(row.repeatableKeywordField.key, instanceIndex)"
                        [disabled]="isInstanceLoading(row.repeatableKeywordField.key, instanceIndex)"
                        (onClick)="copyRepeatableInstance(row.repeatableKeywordField.key, instanceIndex)"
                        pTooltip="Copy this entry" tooltipPosition="top">
                      </p-button>
                      <p-button
                        *ngIf="!readonly && !row.repeatableKeywordField.readOnly && !isLookupDropdown(row.repeatableKeywordField)"
                        icon="pi pi-trash" [text]="true" severity="danger"
                        (onClick)="removeRepeatableInstance(row.repeatableKeywordField.key, instanceIndex)"
                        [disabled]="!canRemoveInstance(row.repeatableKeywordField, instanceGroup, instanceIndex)"
                        pTooltip="Remove this entry">
                      </p-button>
                    </div>
                  </div>
              
                  <div class="duplicate-warning"
                    *ngIf="isDuplicateInstance(row.repeatableKeywordField.key, instanceIndex)">
                    <i class="pi pi-exclamation-triangle"></i>
                    This entry appears to be a duplicate. Please review or remove it.
                  </div>

                  <div class="sub-fields-grid">
                    <ng-container *ngFor="let subField of getSubFields(row.repeatableKeywordField)">
                      <div *ngIf="isSubFieldVisible(subField, instanceGroup)" class="sub-field">
                        <app-field-renderer [field]="subField" [fieldKey]="subField.key"
                          [parentFormGroup]="instanceGroup" [index]="instanceIndex"
                          [readonly]="getSubFieldReadonlyState(subField, row.repeatableKeywordField, instanceGroup)"
                          [fieldEnabled]="isSubFieldEnabled(subField, instanceGroup, row.repeatableKeywordField)">
                        </app-field-renderer>
                      </div>
                    </ng-container>
                  </div>
                </div>

                <!-- Bottom Add Button (shown when at least one entry exists) -->
                <div
                  *ngIf="!readonly && !row.repeatableKeywordField.readOnly && !isLookupDropdown(row.repeatableKeywordField) && getRepeatableInstanceCount(row.repeatableKeywordField.key) > 0"
                  class="bottom-add-button">
                  <p-button icon="pi pi-plus" [rounded]="true" [outlined]="true"
                    (onClick)="addRepeatableInstance(row.repeatableKeywordField)"
                    [disabled]="getRepeatableInstanceCount(row.repeatableKeywordField.key) >= getMaxRepeatCount(row.repeatableKeywordField)"
                    [pTooltip]="
                      getRepeatableInstanceCount(row.repeatableKeywordField.key) >= getMaxRepeatCount(row.repeatableKeywordField)
                        ? 'Maximum number of entries reached'
                        : 'Add new entry'
                    " tooltipPosition="top">
                  </p-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Render tabs if multiple tabs exist -->
    <div *ngIf="formDefinition.tabs.length > 1; else singleTabTemplate" class="tabs-container">
      <p-tabs [value]="activeTabIndex" (valueChange)="onTabChange($event)">
        <p-tablist>
          <p-tab *ngFor="let tab of formDefinition.tabs; let i = index" [value]="i">
            {{ tab.title }}
          </p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel *ngFor="let tab of formDefinition.tabs; let i = index" [value]="i">
            <div class="tab-content" [attr.data-form-tab-index]="i">
              <ng-container
                *ngTemplateOutlet="sectionTemplate; context: { sections: tab.sections, tabIndex: i }"></ng-container>
            </div>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </div>

    <!-- Single tab template - render sections directly -->
    <ng-template #singleTabTemplate>
      <div class="tab-content" data-form-tab-index="0">
        <ng-container
          *ngTemplateOutlet="sectionTemplate; context: { sections: formDefinition.tabs[0].sections, tabIndex: 0 }"></ng-container>
      </div>
    </ng-template>
    }
  </div>
</form>